define([
    'text!product-detail/component/next-product.html',
    'common/utils',
    'product-detail/store',

    'css!product-detail/component/next-product.css'
], function(
    tpl,
    Utils,
    Store
){
    return {
        template: tpl,
        data: function(){
            return {
                products: [],
                nextProductLink: ''
            };
        },
        computed: {
            isPC: function () {
                if($(window).width()<=750){
                    $('.fixed-menu').css({display: 'none'});
                    return false;
                }else {
                    return true;
                }
            }
        },
        methods: {
            init: function(){
                this.products = Store.getNextSku();
            },
            genProductDetailLink: Utils.genProductDetailLink,
            getSkuMainImage: Utils.getSkuMainImage,
            getSkuBgColor: Utils.getSkuBgColor,
            toNext: function () {
                window.load.href(this.genProductDetailLink(this.products.id, this.products.categoryFnji));
            }
        },
        created: function(){
            this.init();
        },
        mounted: function(){
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail2024/component/next-product.js
// module id = 215
// module chunks = 0